import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class CoreService {
  private apiCount = 0;
  private show = true;
  private isLoadingSubject = new BehaviorSubject<boolean>(false);
  isLoading$ = this.isLoadingSubject.asObservable();

  constructor() {}

  showLoader = () => {
    if (this.apiCount === 0) {
      this.isLoadingSubject.next(true);
    }
    this.apiCount++;
  };

  hideLoader = () => {
    if (this.apiCount > 0) this.apiCount--;
    if (this.apiCount === 0) {
      this.isLoadingSubject.next(false);
    }
  };

  addLoader = () => (this.show = true);
  removeLoader = () => (this.show = false);

  displayLoader = () => this.show;
}
